import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import Session from 'supertokens-web-js/recipe/session';

export const register = createAsyncThunk('auth/signup', API.users.register);
export const login = createAsyncThunk('auth/signip', API.users.login);

export const logout = createAsyncThunk('auth/logout', async () => {
  await Session.signOut();
});

export const getUserInfo = createAsyncThunk('auth/user', API.users.fetchUserData);

export const forgot = createAsyncThunk('auth/forgot', API.users.forgot);

export const reset = createAsyncThunk('auth/reset', API.users.reset);
